import { render, staticRenderFns } from "./wageSettlement.vue?vue&type=template&id=c1e4f18e&scoped=true"
import script from "./wageSettlement.vue?vue&type=script&lang=js"
export * from "./wageSettlement.vue?vue&type=script&lang=js"
import style0 from "./wageSettlement.vue?vue&type=style&index=0&id=c1e4f18e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e4f18e",
  null
  
)

export default component.exports